// Shows brand tooltips on hover of .brands-slider__item
const BrandsTooltip = () => {
  const brandsSliderSection = document.querySelector('.brands-slider');
  if (!brandsSliderSection) return;

  const items = Array.from(
    brandsSliderSection.querySelectorAll('.brands-slider__item')
  );
  if (!items.length) return;

  let activeTooltip = null;
  let activeAnchor = null;

  /**
   * Compute and set tooltip side (left/right) based on available space.
   * @param {HTMLElement} tooltip
   * @param {HTMLElement} anchor
   */
  const calculateTooltipPosition = (tooltip, anchor) => {
    const containerRect = brandsSliderSection.getBoundingClientRect();
    const anchorRect = anchor.getBoundingClientRect();
    const tooltipRect = tooltip.getBoundingClientRect();

    tooltip.classList.remove('shift-left', 'shift-right');

    const rightSpace = containerRect.right - anchorRect.left - tooltipRect.width;
    const leftSpace = anchorRect.right - containerRect.left - tooltipRect.width;

    if (rightSpace >= 0) {
      tooltip.classList.add('shift-right');
    } else if (leftSpace >= 0) {
      tooltip.classList.add('shift-left');
    } else {
      if (Math.abs(rightSpace) < Math.abs(leftSpace)) {
        tooltip.classList.add('shift-right');
      } else {
        tooltip.classList.add('shift-left');
      }
    }
  };

  /**
   * Show tooltip for the given item on hover.
   * @param {HTMLElement} item
   */
  const showTooltip = (item) => {
    const tooltip = item.querySelector('.brands-slider__item-tooltip');
    if (!tooltip) return;

    const anchor =
      item.querySelector('.brands-slider__item-tooltip-wrapper') || item;

    if (activeTooltip && activeTooltip !== tooltip) {
      activeTooltip.classList.remove('visible');
    }

    activeTooltip = tooltip;
    activeAnchor = anchor;

    tooltip.classList.add('visible');
    calculateTooltipPosition(tooltip, anchor);
  };

  /**
   * Hide currently active tooltip.
   */
  const hideActiveTooltip = () => {
    if (!activeTooltip) return;
    activeTooltip.classList.remove('visible');
    activeTooltip = null;
    activeAnchor = null;
  };

  /**
   * Bind hover/focus handlers to each item.
   */
  items.forEach((item) => {
    item.addEventListener('mouseenter', () => showTooltip(item));
    item.addEventListener('mouseleave', hideActiveTooltip);

    // Basic keyboard accessibility
    item.addEventListener('focusin', () => showTooltip(item));
    item.addEventListener('focusout', (e) => {
      if (!item.contains(e.relatedTarget)) hideActiveTooltip();
    });
  });

  /**
   * Recalculate position on resize for the active tooltip.
   */
  window.addEventListener('resize', () => {
    if (activeTooltip && activeAnchor) {
      calculateTooltipPosition(activeTooltip, activeAnchor);
    }
  });
};

export default BrandsTooltip;